<template>
  <div>
    <content-nav-bar>
      <p class="is-size-4">App Build Info</p>
    </content-nav-bar>
    <detail-item
      name="Build Date"
      imgName="cal">
      {{ VUE_APP_BUILD_DATE | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="GIT_VERSION"
      imgName="circle">
      {{ VUE_APP_GIT_VERSION }}
    </detail-item>
    <detail-item
      name="GIT_HASH"
      imgName="circle">
      {{ VUE_APP_GIT_HASH }}
    </detail-item>
    <detail-item
      name="GIT_BRANCH"
      imgName="circle">
      {{ VUE_APP_GIT_BRANCH }}
    </detail-item>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import gmt from '@/mixins/gmt';
import DetailItem from '@/components/DetailItem.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';

export default {
  name: 'BuildInfo',
  components: { DetailItem, ContentNavBar },
  mixins: [gmt],
  computed: {
    ...mapState(['VUE_APP_GIT_VERSION', 'VUE_APP_GIT_HASH', 'VUE_APP_GIT_BRANCH', 'VUE_APP_BUILD_DATE']),
  },
};
</script>
